(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var mobileMedia = window.matchMedia(MOBILE_QUERY);

  function getSpaceBetween(nav) {
    var mobile = parseInt(nav.dataset.spaceMobile || '4', 10);
    var desktop = parseInt(nav.dataset.spaceDesktop || '24', 10);
    return mobileMedia.matches ? mobile : desktop;
  }

  function getEdgeInset(nav) {
    var styles = window.getComputedStyle(nav);
    var value = styles.getPropertyValue('--sub-collections-nav-edge-inset').trim();
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 20;
  }

  function getActiveItemIndex(nav) {
    var items = nav.querySelectorAll('.sub-collections-nav__item');

    for (var i = 0; i < items.length; i++) {
      if (items[i].querySelector('.sub-collections-nav__link.is-active')) {
        return i;
      }
    }

    return 0;
  }

  function revealActiveSlide(swiper, nav) {
    var index = getActiveItemIndex(nav);
    swiper.slideTo(index, 0, false);
  }

  function refreshSwiper(swiper, nav) {
    swiper.params.spaceBetween = getSpaceBetween(nav);
    swiper.update();
    revealActiveSlide(swiper, nav);
  }

  /**
   * True when any slide edge or configured leading/trailing inset exceeds the track.
   * Uses visual bounds so even ~1px of overflow enables swiping.
   */
  function slidesOverflowTrack(nav, track) {
    var list = nav.querySelector('.sub-collections-nav__list');
    if (!list || !list.children.length) return false;

    var trackWidth = track.clientWidth;
    if (trackWidth <= 0) return false;

    if (list.scrollWidth - trackWidth > 0.5) return true;

    var trackRect = track.getBoundingClientRect();
    var items = list.children;
    var firstRect = items[0].getBoundingClientRect();
    var lastRect = items[items.length - 1].getBoundingClientRect();

    if (firstRect.left < trackRect.left - 0.5 || lastRect.right > trackRect.right + 0.5) {
      return true;
    }

    var gap = getSpaceBetween(nav);
    var contentWidth = 0;

    for (var i = 0; i < items.length; i++) {
      contentWidth += items[i].getBoundingClientRect().width;
      if (i > 0) contentWidth += gap;
    }

    var inset = getEdgeInset(nav);

    return contentWidth + inset * 2 > trackWidth + 0.5;
  }

  function shouldUseSwiper(nav, track) {
    return slidesOverflowTrack(nav, track);
  }

  function clearSwiperClasses(nav) {
    var track = nav.querySelector('.sub-collections-nav__track');
    var list = nav.querySelector('.sub-collections-nav__list');

    if (!track || !list) return;

    track.classList.remove('swiper', 'sub-collections-nav__swiper');
    list.classList.remove('swiper-wrapper');

    list.querySelectorAll('.sub-collections-nav__item').forEach(function (slide) {
      slide.classList.remove('swiper-slide');
    });
  }

  function applySwiperClasses(nav) {
    var track = nav.querySelector('.sub-collections-nav__track');
    var list = nav.querySelector('.sub-collections-nav__list');

    if (!track || !list) return;

    track.classList.add('swiper', 'sub-collections-nav__swiper');
    list.classList.add('swiper-wrapper');

    list.querySelectorAll('.sub-collections-nav__item').forEach(function (slide) {
      slide.classList.add('swiper-slide');
    });
  }

  function bindLayoutUpdates(nav) {
    nav.querySelectorAll('.sub-collections-nav__image').forEach(function (image) {
      if (image.complete) return;

      image.addEventListener(
        'load',
        function () {
          updateNav(nav);
        },
        { once: true }
      );
    });
  }

  function destroySwiper(nav) {
    if (!nav.subCollectionsSwiper) return;

    nav.subCollectionsSwiper.destroy(true, true);
    nav.subCollectionsSwiper = null;
  }

  function enableStaticLayout(nav) {
    destroySwiper(nav);
    clearSwiperClasses(nav);
    nav.classList.add('sub-collections-nav--static');
    bindLayoutUpdates(nav);
  }

  function enableSwiper(nav) {
    nav.classList.remove('sub-collections-nav--static');

    var track = nav.querySelector('.sub-collections-nav__track');
    if (!track || typeof Swiper === 'undefined') return;

    applySwiperClasses(nav);

    if (nav.subCollectionsSwiper) {
      nav.subCollectionsSwiper.destroy(true, true);
      nav.subCollectionsSwiper = null;
    }

    var activeIndex = getActiveItemIndex(nav);

    var swiper = new Swiper(track, {
      slidesPerView: 'auto',
      spaceBetween: getSpaceBetween(nav),
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      centeredSlides: false,
      initialSlide: activeIndex,
      speed: 300,
      watchOverflow: false,
      allowTouchMove: true,
      resistanceRatio: 0.85,
      touchRatio: 1,
      threshold: 5,
      passiveListeners: true,
      observer: true,
      observeParents: true,
      on: {
        init: function (instance) {
          refreshSwiper(instance, nav);
          requestAnimationFrame(function () {
            refreshSwiper(instance, nav);
          });
          bindLayoutUpdates(nav);
        },
        resize: function (instance) {
          refreshSwiper(instance, nav);
        },
      },
    });

    nav.subCollectionsSwiper = swiper;
  }

  function updateNav(nav) {
    var track = nav.querySelector('.sub-collections-nav__track');
    if (!track) return;

    if (shouldUseSwiper(nav, track)) {
      enableSwiper(nav);

      if (nav.subCollectionsSwiper && nav.subCollectionsSwiper.params) {
        nav.subCollectionsSwiper.params.allowTouchMove = true;
        nav.subCollectionsSwiper.enable();
      }

      return;
    }

    enableStaticLayout(nav);
  }

  function initNav(nav) {
    updateNav(nav);
  }

  function initAll() {
    document.querySelectorAll('[data-sub-collections-nav]').forEach(initNav);
  }

  function waitForSwiperAndInit() {
    if (typeof Swiper !== 'undefined') {
      initAll();
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        window.clearInterval(timer);
        initAll();
      } else if (attempts > 100) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  var resizeFrame;

  function onViewportChange() {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(function () {
      document.querySelectorAll('[data-sub-collections-nav]').forEach(updateNav);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiperAndInit);
  } else {
    waitForSwiperAndInit();
  }

  window.addEventListener('resize', onViewportChange);
  mobileMedia.addEventListener('change', onViewportChange);

  document.addEventListener('shopify:section:load', function (event) {
    var nav = event.target.querySelector('[data-sub-collections-nav]');
    if (nav) initNav(nav);
  });
})();
